var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1036.29 737.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4,.cls-6{fill:none;}.cls-2{fill:#949494;}.cls-3{fill:#f2f2f2;}.cls-4,.cls-6{stroke:#000;}.cls-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}.cls-5{fill:url(#New_Pattern);}.cls-6{stroke-miterlimit:10;stroke-width:8.09px;}"), /*#__PURE__*/React.createElement("pattern", {
    id: "New_Pattern",
    "data-name": "New Pattern",
    width: 12,
    height: 12,
    patternTransform: "matrix(-1, 0, 0, 1, 10.59, -37.18)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12,
    cy: 3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cy: 3,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 6,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 6,
    cy: 12,
    r: 2
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "handshake-monochrome") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M953.87,424.66l-102,54.1L743.16,290.43c16.46-9.54,42-24.68,71-42-38.46-42.37-76.68-80.16-117.87-119.12C624.57,61.19,544-10.82,472,1.36,423.72,9.55,379.44,56,331.4,105.42H575.05v99.7H531.11l-17.28,36.32-17.28-36.32H323.88v-92c-21,21.57-42.86,43.37-66.1,62.52-22.49,18.48-46.31,34.53-70,49.59L351,363.31s120.93-37.17,131.29-36c11.44,1.3,25.81,9.15,41.52,21.12h0c9.84-4.16,18-7.49,22.23-9.05,17.8-6.47,76.07,14.57,89,16.19s51.79-17.81,58.45-21.75l92.92,161s-91,54.79-127.43,75.36h0c-24.06,37.46-78,87-166.4,90.9-5-2-22.67-12.81-47.22-28.52l1.72-.5-1.23-.13c-7.43,9.75-24.61,21.3-34.9,19.79-12.64-1.86-102.19-60.94-113.71-77.66-9.44-13.71-7.65-35.89-6.69-43.45h0c-53-35.45-97.32-65.41-103.7-69.93C173,450.84,79.09,392.51,29.8,351.88-13,420.62-9.7,519.18,39.68,582.1c51.29,65,152,91.95,231.05,109,78.75,17.09,135.73,24.35,198.68,32.64,62.68,8.54,131.84,18.13,243,11.39,111.38-6.47,265-29.27,302.28-100C1042.84,581.57,1004.78,500.59,953.87,424.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M445.33,632.51c24.55,15.71,42.24,26.56,47.22,28.52,88.4-3.86,142.34-53.44,166.4-90.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.63,76.42s44.21,34.72,76.46,61.09L351,363.31s120.93-37.17,131.29-36c11.44,1.3,25.81,9.15,41.52,21.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.52,530.56c-53-35.45-97.32-65.41-103.7-69.93C170.41,449,41.14,369,7.63,331.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "879.12 525.92 823.05 558.29 687.09 322.8 743.16 290.43 879.12 525.92"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834.09,
    cy: 512.57,
    r: 17.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M693.46,333.82c-6.66,3.94-45.5,23.37-58.45,21.75s-71.22-22.66-89-16.19-102,43.7-102,43.7-76.08,80.93-77.7,82.55-.09,14.21,2.23,16.22,28.46,9.9,32.79,7.27,62.8-47.49,73.32-47.49,110.88,72.13,170.66,135.8c13.79-6,141.06-82.66,141.06-82.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.9,527.93s-5.21,29.36,6.31,46.08,101.07,75.8,113.71,77.66,35.67-16,38.27-26-14.12-46.82-18.95-52S356.29,520.13,348.86,519,302.42,520.87,290.9,527.93Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 299.64,
    y1: 577.43,
    x2: 349.13,
    y2: 539.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 338.48,
    y1: 608.87,
    x2: 387.98,
    y2: 571.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 376.37,
    y1: 633.31,
    x2: 413.98,
    y2: 604.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 617.15,
    y1: 615.61,
    x2: 476.34,
    y2: 501.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 564.78,
    y1: 644.75,
    x2: 475.47,
    y2: 572.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 520.13,
    y1: 660.21,
    x2: 446.64,
    y2: 600.49
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.73,
    y: 322.77,
    width: 117.05,
    height: 127.87,
    rx: 23.74,
    ry: 23.74,
    transform: "translate(290.68 -13.97) rotate(40.53)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "231.44 359.87 182.29 317.84 231.93 259.77 281.09 301.8 231.44 359.87"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 226.49,
    cy: 654.69,
    r: 20.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 737.68,
    cy: 624.87,
    r: 14.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 638.51,
    cy: 286.38,
    r: 14.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "575.05 105.42 323.88 105.42 323.88 205.12 496.55 205.12 513.83 241.44 531.11 205.12 575.05 205.12 575.05 105.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 357.98,
    y1: 130.8,
    x2: 540.94,
    y2: 130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 357.98,
    y1: 155.27,
    x2: 540.94,
    y2: 155.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 357.98,
    y1: 179.73,
    x2: 540.94,
    y2: 179.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1035,115.61l-18.14,10.93S808.48,252.59,743.16,290.43L851.9,478.76,1035,381.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShake);
export default __webpack_public_path__ + "static/media/shake.c7165a1f59e2367bf4395199384f606f.svg";
export { ForwardRef as ReactComponent };